<template>
  <v-container fluid>
    <div id="mapDiv"></div>
    <v-row align="start" justify="end">
      <v-card :width="$vuetify.breakpoint.lgAndUp ? 80 : 50"
      color="black" class="text-center">
        <span>{{geofenceName}}</span>
        <!-- <v-img width=80 src="/button_filmstrip.png" />
        <span class="body-2 white--text">Filmstrip</span>
        <v-img width=80 src="/button_gallery.png" />
        <span class="body-2 white--text">Gallery</span>
        <v-img width=80 src="/button_timelapse.png" />
        <span class="body-2 white--text">Timelapse</span> -->
        <v-img width=80 src="/button_adjust.png" @click="radiusDialog = true" />
        <v-dialog v-model="radiusDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">Change geofence radius</v-card-title>
            <v-card-text>
              Change geofence radius
            </v-card-text>
            <v-text-field class="ma-2" label="Radius (m)" v-model="radiusField"></v-text-field>
            <v-card-actions>
              <v-btn
                color="green darken-1"
                text
                @click="removeDialog = true"
              >
                Remove geofence
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="radiusDialog = false"
              >
                Cancel
              </v-btn>

              <v-btn
                color="green darken-1"
                text
                @click="saveRadius"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="radiusWarningSnackbar">
          Radius cannot be under 10m.
        </v-snackbar>
        <v-dialog v-model="removeDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">Remove geofence</v-card-title>
            <v-card-text>
              Remove geofence?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="removeDialog = false"
              >
                Cancel
              </v-btn>

              <v-btn
                color="green darken-1"
                text
                @click="removeGeofence"
              >
                Remove
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span class="body-2 white--text">Adjust geofence</span>
        <!-- <v-switch class="justify-center" color="white"
        v-model="enabledSwitch" @click="enabledSwitchClick"></v-switch>
        <span style="color: white">Enabled</span> -->
      </v-card>
    </v-row>
    <v-card style="position: absolute; bottom: 0" color="black">
      <v-row align="center" justify="center">
        <v-col cols=1>
          <v-btn class="ma-5" fab @click="sliderPrevious">
              <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols=2 v-for="thumb in thumbnails" :key="thumb.url">
          <v-card @click="thumbClicked(thumb)">
            <GeolapseThumbnail
              v-if="thumb"
              class="mt-n2 mb-n2"
              :image="thumb"
            ></GeolapseThumbnail>
          </v-card>
        </v-col>
        <v-col cols=2 v-for="index in placeholderThumbnails" :key="index">
          <v-card width="340"></v-card>
        </v-col>
        <v-col cols=1>
          <v-btn class="ma-5" fab @click="sliderNext">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="imageDialog" :width="$vuetify.breakpoint.lgAndUp ? 1200 : 500">
      <v-card class="pl-6 pr-6">
        <v-card-title>Captured on {{imageTimestamp}} with {{deviceName}}</v-card-title>
        <v-row align="center" justify="center">
          <v-col cols=1>
            <v-btn class="ma-5" fab @click="previousImage">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols=10>
            <GeolapseImage360 v-if="isVrCamera" :image="imageToOpen"></GeolapseImage360>
            <GeolapseImage v-else :image="imageToOpen"></GeolapseImage>
          </v-col>
          <v-col cols=1>
            <v-btn class="ma-5" fab @click="nextImage">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
#mapDiv {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 0;
}
</style>

<script>

import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import GeolapseImage from '@/components/Geolapse/GeolapseImage.vue';
import GeolapseImage360 from '@/components/Geolapse/GeolapseImage360.vue';
import GeolapseThumbnail from '@/components/Geolapse/GeolapseThumbnail.vue';
import gql from 'graphql-tag';
import EventBus from '@/utils/EventBus';

const QUERY_GEOFENCE_THUMBNAILS = gql`
  query getGeofenceFiles($geofence_id: String!, $offset: Int!) {
    get_geofence_files(
      args: {search: $geofence_id
      }
      order_by: { created: desc }
      limit: 5,
      offset: $offset
    ) {
      id
      location
      created
      url
      distance
    }
  }
`;

const SUBSCRIPTION_GEOFENCE = gql`
subscription get_geofence($id: String!) {
  geofences_by_pk(id: $id) {
    id
    enabled
    location
    radius
    name
    device {
      id
      name
      description
    }
  }
}
`;

const UPDATE_GEOFENCE_RADIUS = gql`
mutation update_geofence_radius($id: String!, $radius: Int!) {
  update_geofences_by_pk(
    pk_columns: { id: $id },
    _set: {
      radius: $radius
    }
  ) {
    id
    enabled
    location
    radius
    name
  }
}
`;

const UPDATE_GEOFENCE_ENABLED = gql`
mutation update_geofence_enabled($id: String!, $enabled: Boolean!) {
  update_geofences_by_pk(
    pk_columns: { id: $id },
    _set: {
      enabled: $enabled
    }
  ) {
    id
    enabled
    location
    radius
    name
  }
}
`;

const REMOVE_GEOFENCE = gql`
mutation remove_geofence($id: String!) {
  delete_geofences_by_pk (
    id: $id
  ) {
    id
  }
}
`;

const UPDATE_USER_MAPLAYER = gql`
mutation update_user_maplayer($sub: String!, $map_layer: String!) {
  update_users_by_pk(
    pk_columns: { sub: $sub },
    _set: {
      map_layer: $map_layer
    }
  ) {
    map_layer
  }
}
`;

export default {
  name: 'Geofence',
  data() {
    return {
      map: null,
      enabled: false,
      geofenceId: null,
      geofence: null,
      device: null,
      markers: null,
      radiusDialog: false,
      radiusField: 0,
      enabledSwitch: false,
      ignoreOnce: true,
      removeDialog: false,
      ignoreLayerSelectionOnce: true,
      radiusWarningSnackbar: false,
      images: null,
      thumbnails: null,
      imageDialog: false,
      imageToOpen: null,
      currentImageIndex: -1,
      currentThumbnailOffset: 0,
      placeholderThumbnails: 0,
    };
  },
  components: {
    GeolapseThumbnail,
    GeolapseImage,
    GeolapseImage360,
  },
  computed: {
    imageTimestamp() {
      if (this.imageToOpen) {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];

        const d = new Date(this.imageToOpen.created);
        const space = ' ';
        const colon = ':';
        // eslint-disable-next-line
        const minutes = '' + d.getMinutes();
        const date = d.getDate() + space + months[d.getMonth()] + space + d.getFullYear()
        + space + d.getHours() + colon + minutes.padStart(2, '0') + colon + d.getSeconds();
        return date;
      }
      return null;
    },
    geofenceName() {
      if (this.geofence) {
        return this.geofence.name;
      }
      return '';
    },
    deviceName() {
      if (this.device) {
        return this.device.name;
      }
      return '';
    },
    isVrCamera() {
      if (!this.device) {
        return false;
      }
      const { description } = this.device;
      const vrCameras = [
        'Ricoh Theta V',
        'Theta V',
        'Ricoh Theta Z1',
        'Theta Z1',
        'Labpano Pilot One (EE)',
        'Labpano Pilot Era',
      ];
      return !!(vrCameras.find((el) => el === description));
    },
  },
  mounted() {
    this.geofenceId = this.$store.state.currentGeofenceId;
    this.device = this.$store.state.currentDevice;

    // eslint-disable-next-line
    const mapBoxSatellite = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaGVpa2tpcyIsImEiOiJjanp3YnBvaGwwZDR0M2hwZ29zdXZmeDh4In0.cxRko2MWKrQ520oi1G0_9A', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '© <a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    // eslint-disable-next-line
    const mapBoxStreets = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaGVpa2tpcyIsImEiOiJjanp3YnBvaGwwZDR0M2hwZ29zdXZmeDh4In0.cxRko2MWKrQ520oi1G0_9A', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '© <a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    const openStreetMap = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    });
    const maanmittauslaitos = L.tileLayer('https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/maastokartta/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png', { id: 'Maastokartta' });

    let defaultLayerName = this.$store.state.mapLayer;
    if (defaultLayerName === undefined || defaultLayerName === null) {
      console.log('defaultti');
      defaultLayerName = 'Maanmittauslaitos';
    } else {
      console.log(defaultLayerName);
    }

    const mapLayers = {
      // eslint-disable-next-line
      'MapBoxSatellite': mapBoxSatellite,
      // eslint-disable-next-line
      'MapBoxStreets': mapBoxStreets,
      // eslint-disable-next-line
      'OpenStreetMap': openStreetMap,
      // eslint-disable-next-line
      'Maanmittauslaitos': maanmittauslaitos,
    };

    this.map = L.map('mapDiv', {
      minZoom: 4,
      maxZoom: 18,
      zoomControl: false,
      layers: [mapLayers[defaultLayerName]],
    });
    this.map.on('baselayerchange ', this.layerSelected);

    L.control.layers(mapLayers, null, { position: 'topleft' }).addTo(this.map);

    this.markers = new L.FeatureGroup();
    this.map.addLayer(this.markers);

    this.getImages(0);

    EventBus.$on('leavingGeofence', this.leaving);
  },
  beforeDestroy() {
    EventBus.$off('leavingGeofence', this.leaving);
  },
  methods: {
    leaving() {
      this.$store.commit('currentMapZoomLevel', this.map.getZoom());
      this.$store.commit('currentMapLocation', this.map.getCenter());
    },
    sliderPrevious() {
      console.log('sliderPrevious');
      this.currentThumbnailOffset -= 5;
      if (this.currentThumbnailOffset < 0) {
        this.currentThumbnailOffset = 0;
      }
      this.getImages(this.currentThumbnailOffset);
    },
    sliderNext() {
      console.log('sliderNext');
      if (this.thumbnails.length === 5) {
        this.currentThumbnailOffset += 5;
        this.getImages(this.currentThumbnailOffset);
      }
    },
    getThumbnails() {
      this.thumbnails = [];
      this.images.forEach((image) => {
        const thumb = { ...image };
        const urlStart = thumb.url.substring(0, thumb.url.lastIndexOf('.'));
        const urlEnd = thumb.url.substring(thumb.url.lastIndexOf('.'));
        // eslint-disable-next-line
        thumb.url = urlStart + '_thumb' + urlEnd;
        this.thumbnails.push(thumb);
      });

      this.placeholderThumbnails = 5 - this.thumbnails.length;
    },
    async getImages(offsetValue) {
      const result = await this.$apollo.query({
        query: QUERY_GEOFENCE_THUMBNAILS,
        variables: {
          geofence_id: this.geofenceId,
          offset: offsetValue,
        },
        fetchPolicy: 'network-only',
      });

      this.images = result.data.get_geofence_files;
      this.getThumbnails();
    },
    thumbClicked(thumb) {
      this.currentImageIndex = this.thumbnails.indexOf(thumb);
      this.openImage();
    },
    openImage() {
      this.imageToOpen = this.images[this.currentImageIndex];
      this.imageDialog = true;
    },
    previousImage() {
      // eslint-disable-next-line
      console.log('current index: ' + this.currentImageIndex);
      // eslint-disable-next-line
      this.currentImageIndex--;
      if (this.currentImageIndex < 0) {
        this.sliderPrevious();
        this.currentImageIndex = 5;
      }
      this.openImage();
    },
    nextImage() {
      // eslint-disable-next-line
      console.log('current index: ' + this.currentImageIndex);
      // eslint-disable-next-line
      this.currentImageIndex++;
      if (this.currentImageIndex > this.thumbnails.length - 1) {
        this.sliderNext();
        this.currentImageIndex = 0;
      }
      this.openImage();
    },
    enabledSwitchClick() {
      if (this.ignoreOnce) {
        this.ignoreOnce = false;
        return;
      }
      this.enabledSwitch = !this.enabledSwitch;
      if (this.enabledSwitch !== this.geofence.enabled) {
        this.saveEnabled();
      }

      this.ignoreOnce = true;
    },
    updateView() {
      if (this.geofence && !this.device) {
        this.device = this.geofence.device;
      }

      this.radiusField = this.geofence.radius;
      this.enabledSwitch = this.geofence.enabled;

      this.markers.clearLayers();

      if (this.geofence && this.geofence.location && this.geofence.location.coordinates) {
        L.circle([this.geofence.location.coordinates[0],
          this.geofence.location.coordinates[1]], {
          radius: this.geofence.radius, fillOpacity: 0.25, color: this.geofence.enabled ? '#00ff00' : '#808080',
        }).addTo(this.markers);

        this.map.setView(new L.LatLng(this.geofence.location.coordinates[0],
          this.geofence.location.coordinates[1]), this.$store.state.currentMapZoomLevel);
      }
    },
    saveRadius() {
      const id = this.geofenceId;
      const radius = this.radiusField;

      if (radius < 10) {
        this.radiusWarningSnackbar = true;
        return;
      }

      const variables = {
        id,
        radius,
      };

      this.$apollo.mutate({
        mutation: UPDATE_GEOFENCE_RADIUS,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_geofences } }) => {
          // TODO error handling what if mutation doesn't work
        },
      });

      this.radiusDialog = false;
      this.getImages(0);
    },
    saveEnabled() {
      const id = this.geofenceId;
      const enabled = this.enabledSwitch;

      const variables = {
        id,
        enabled,
      };

      this.$apollo.mutate({
        mutation: UPDATE_GEOFENCE_ENABLED,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_geofences } }) => {
          // TODO error handling what if mutation doesn't work
        },
      });

      this.radiusDialog = false;
    },
    removeGeofence() {
      this.removeDialog = false;

      const id = this.geofenceId;
      const variables = {
        id,
      };
      this.$apollo.mutate({
        mutation: REMOVE_GEOFENCE,
        variables,
      })
        .then((/* data */) => {
          this.$router.push({ name: 'Geolapse' });
        })
        .catch((e) => {
          console.error(e);
        });
    },
    layerSelected(e) {
      if (this.ignoreLayerSelectionOnce) {
        this.ignoreLayerSelectionOnce = false;
        return;
      }
      // eslint-disable-next-line
      console.log('selected layer: ' + e.name);
      this.$store.commit('mapLayer', e.name);
      this.saveMapLayer();
    },
    saveMapLayer() {
      // eslint-disable-next-line
      const sub = this.$store.state.user.attributes.sub;
      // eslint-disable-next-line
      const map_layer = this.$store.state.mapLayer;

      const variables = {
        sub,
        map_layer,
      };

      this.$apollo.mutate({
        mutation: UPDATE_USER_MAPLAYER,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_users } }) => {
          // TODO error handling what if mutation doesn't work
        },
      });
    },
  },
  apollo: {
    $subscribe: {
      geofence: {
        query: SUBSCRIPTION_GEOFENCE,
        variables() {
          return {
            id: this.geofenceId,
          };
        },
        result(data) {
          this.geofence = data.data.geofences_by_pk;
          this.updateView();
        },
      },
    },
  },
};
</script>
